<template>
  <div class="login-form-container">
    <h2>Zugangsdaten eingeben</h2>

    <form>
      <div class="input_field">
        <label for="email">E-Mail-Adresse</label>
        <input
          type="email"
          id="email"
          v-model="email"
          placeholder="E-Mail-Adresse eingeben"
          required
        />
      </div>
      <div class="input_field">
        <label for="password">Passwort</label>
        <div class="password-wrapper">
          <input
            :type="showPassword ? 'text' : 'password'"
            id="password"
            v-model="password"
            placeholder="Passwort eingeben"
            required
          />
          <i
            class="fas"
            :class="showPassword ? 'fa-eye-slash' : 'fa-eye'"
            @click="togglePasswordVisibility"
          ></i>
        </div>
        <div class="reset-link">
          <span>Passwort vergessen? </span>
          <a @click.prevent="onResetPassword">Passwort zurücksetzen</a>
        </div>
      </div>

      <p class="disclaimer">
        Wenn Sie fortfahren, bestätigen Sie, dass Sie die
        <a href="https://codelos.notion.site/agb" target="_blank"
          >Allgemeinen Geschäftsbedingungen</a
        >
        und die
        <a href="https://codelos.notion.site/datenschutz" target="_blank"
          >Datenschutzrichtlinie</a
        >
        verstanden haben und ihnen zustimmen.
      </p>
    </form>
    <div v-if="message?.length" class="session-expired">{{ message }}</div>
    <div class="footer">
      <button @click="onclicklogin" type="submit">
        <span v-if="!loading">ANMELDEN</span>
        <div v-else class="progress-icon"></div>
      </button>
      <p class="error" v-if="errorMessage && errorMessage.length">
        {{ errorMessage }}
      </p>
    </div>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify';
import { putUserLoginDetails } from '../../services/axios/data.api';
export default {
  name: 'LoginForm',
  props: ['message'],
  data() {
    return {
      email: '',
      password: '',
      showPassword: false,
      errorMessage: null,
      loading: false,
      awsErrorMessages: {
        NotAuthorizedException: 'Benutzername oder Passwort falsch.',
        UserNotFoundException: 'Benutzername oder Passwort falsch.',
        LimitExceededException:
          'Versuchslimit überschritten. Bitte versuchen Sie es später erneut.',
      },
    };
  },
  methods: {
    async onclicklogin() {
      if (this.loading) return;
      try {
        this.loading = true;
        this.errorMessage = null;
        if (!this.email) {
          this.errorMessage = 'Bitte geben Sie einen Benutzernamen ein';
          return;
        }
        if (!this.password) {
          this.errorMessage = 'Bitte geben Sie ein Passwort ein';
          return;
        }
        const user = await Auth.signIn(this.email, this.password);
        if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
          this.$emit('onNewPassword', user);
        } else {
          putUserLoginDetails();
          await this.$router.push({
            path: '/',
            query: this.parsedRedirectQueryParams,
          });
        }
      } catch (error) {
        if (error.code) {
          this.errorMessage =
            this.awsErrorMessages[error.code] || error.message;
        }
      } finally {
        this.loading = false;
      }
    },
    onResetPassword() {
      if (!this.loading) this.$emit('onResetPassword');
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
  },
  computed: {
    parsedRedirectQueryParams() {
      const redirect = this.$route.query.redirect;
      if (!redirect || !redirect.includes('?')) return {};

      const queryString = redirect.split('?')[1];
      const params = new URLSearchParams(queryString);

      const result = {};
      for (const [key, value] of params.entries()) {
        result[key] = value;
      }

      return result;
    },
  },
};
</script>

<style scoped>
.login-form-container {
  max-width: 60%;
  width: 100%;
  background-color: white;
  box-sizing: border-box;
  text-align: left;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 0 auto;
  position: relative;
}

.login-form-container h2 {
  font-size: 36px;
  margin-bottom: 30px;
  color: #152939;
  font-weight: 500;
  white-space: nowrap;
}

.login-form-container .session-expired {
  width: 100%;
  color: red;
  text-align: center;
  padding: 0;
  margin: 0 0 24px;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 29px;
  font-weight: 500;
  letter-spacing: -0.32px;
}

.login-form-container form {
  margin: 0 0 0px 0;
}

.login-form-container form .input_field {
  width: 100%;
  max-width: 100%;
  margin: 0 0 22px;
}

.login-form-container form .input_field label {
  font-size: 14px;
  color: #152939;
  margin-bottom: 8px;
  width: 100%;
  max-width: 100%;
  padding: 0px;
  font-weight: 600;
  line-height: 29px;
  letter-spacing: -0.32px;
  position: relative;
  top: 0;
  left: 0;
}

.login-form-container form .input_field label::after {
  content: ' *';
  color: red;
}
.login-form-container form .input_field input {
  width: 100%;
  max-width: 100%;
  padding: 6px 16px;
  border: 1.2px solid #bbbbbb;
  border-radius: 10px;
  font-size: 16px;
  box-sizing: border-box;
  height: 60px;
  color: #5f697a !important;
  cursor: text;
  line-height: 19px;
  letter-spacing: 0.125px;
  font-weight: 400;
}
.login-form-container form .input_field input:focus {
  outline: none;
  box-shadow: none;
}

.login-form-container form .input_field input:-webkit-autofill {
  box-shadow: 0 0 0 1000px white inset !important;
  -webkit-box-shadow: 0 0 0 1000px white inset !important;
  -webkit-text-fill-color: #5f697a !important;
  font-size: 16px !important;
}

.login-form-container form .input_field .password-wrapper {
  position: relative;
}

.login-form-container form .input_field .password-wrapper input {
  padding-right: 2.5rem;
}

.login-form-container form .input_field .password-wrapper i {
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  cursor: pointer;
  color: #888;
}

.login-form-container form .reset-link {
  margin: 10px 0;
  font-size: 12px;
  color: #828282;
}

.login-form-container form .reset-link a {
  color: #828282;
  cursor: pointer;
  text-decoration: underline !important;
}

.login-form-container form .disclaimer {
  font-size: 12px;
  color: grey;
  line-height: 18px;
  margin: 20px 0;
}

.login-form-container form .disclaimer a {
  color: #666;
  text-decoration: underline;
  cursor: pointer;
}
.login-form-container .footer {
  width: 100%;
  max-width: 100%;
  position: relative;
}
.login-form-container .footer button {
  width: 100%;
  max-width: 100%;
  display: inline-block;
  padding: 10px 16px;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  user-select: none;
  background-color: #000000;
  border-radius: 8px;
  border: 1px solid #000 !important;
  transition: all 0.2s ease-in-out;
  height: 60px;
}
.login-form-container .footer button span {
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: normal;
  line-height: 38px;
  transition: all 0.2s ease-in-out;
}

.login-form-container .footer button:hover {
  background-color: transparent;
}
.login-form-container .footer button:hover span {
  color: #000000;
}
.login-form-container .error {
  position: absolute;
  left: 0;
  top: 65px;
}

.login-form-container .footer button .progress-icon {
  content: ' ';
  display: block;
  width: 25px;
  height: 25px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: progress-icon-animation 1.2s linear infinite;
  margin: 0 auto;
}
.login-form-container .footer button:hover .progress-icon {
  border: 2px solid #000000;
  border-color: #000000 transparent #000000 transparent;
}

@keyframes progress-icon-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* media query */
@media (max-width: 767px) {
  .login-form-container {
    max-width: calc(100% - 50px);
  }

  .login-form-container h2 {
    font-size: 24px;
  }
}
</style>
